import Post, {IPost} from '@/models/Post'
import {IMedium, Medium} from '@/models/Medium'
import Job, {IJob} from '@/models/Job'
import { KeyPair } from '@/types/KeyPair'

export interface IRecruit extends IPost {
  catch_copy?: string
  pr?: string
  business?: string
  atmosphere?: string
  address?: string
  employee?: number
  url?: string
  youtube?: string
  interview_ids?: string
  news_ids?: string
  company_image1?: IMedium
  company_image2?: IMedium
  company_image3?: IMedium
  jobs: Array<IJob>
  viewable_jobs?: Array<IJob>
  plan: string
}

export default class Recruit extends Post {
  catch_copy?: string
  pr?: string
  business?: string
  atmosphere?: string
  address?: string
  employee?: number
  url?: string
  youtube?: string
  interview_ids?: string
  news_ids?: string
  company_image1?: Medium
  company_image2?: Medium
  company_image3?: Medium
  jobs: Array<Job> = []
  viewable_jobs?: Array<Job> = []
  plan: string

  constructor(defaults?: IRecruit) {
    super(defaults)
    if (defaults) {
      this.catch_copy = defaults.catch_copy
      this.pr = defaults.pr || ''
      this.business = defaults.business || ''
      this.atmosphere = defaults.atmosphere || ''
      this.address = defaults.address
      this.employee = defaults.employee
      this.url = defaults.url
      this.youtube = defaults.youtube
      this.interview_ids = defaults.interview_ids
      this.news_ids = defaults.news_ids
      this.company_image1 = defaults.company_image1 ? new Medium(defaults.company_image1) : undefined
      this.company_image2 = defaults.company_image2 ? new Medium(defaults.company_image2) : undefined
      this.company_image3 = defaults.company_image3 ? new Medium(defaults.company_image3) : undefined
      this.jobs = defaults.jobs?.map(j => new Job(j)) || []
      this.viewable_jobs = defaults.viewable_jobs?.map(j => new Job(j)) || []
      this.plan = defaults.plan
    }
  }

  get className(): string {
    return Recruit.name
  }

  get viewableJobs(): Array<Job> {
    return this.jobs.filter(job => job.status === 'publish')
  }

  get contentEscapeHtml(): string {
    return '「ITキャリア沖縄」は沖縄県内のIT/Web業界の求人に特化した転職情報サイト。エンジニアのUIターン採用に積極的な、沖縄県内IT企業の最新求人情報の一覧です。最新情報を随時更新しています。定期的な情報提供をご希望の方は会員登録（無料）ください。'
  }

  get subscribed(): boolean {
    return this.plan === 'pro' || this.plan === 'pending'
  }

  get planString(): string {
    switch (this.plan) {
      case 'pending':
        return '未定'
      case 'basic':
        return '無料掲載企業'
      case 'pro':
        return '人材紹介サービス契約企業'
    }
  }

  toParams(): KeyPair {
    return Object.assign({}, super.toParams(), {
      catch_copy: this.catch_copy,
      pr: this.pr,
      business: this.business,
      atmosphere: this.atmosphere,
      address: this.address,
      employee: this.employee,
      url: this.url,
      youtube: this.youtube,
      interview_ids: this.interview_ids,
      news_ids: this.news_ids,
      company_image1_id: this.company_image1?.id || null,
      company_image2_id: this.company_image2?.id || null,
      company_image3_id: this.company_image3?.id || null,
      plan: this.plan,
      job_params: this.jobs.map(j => j.toParams())
    })
  }
}
